import { Component, OnInit } from '@angular/core';
import { SubmenuService } from '../../submenu/submenu.service';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from 'src/app/services/users/user.service';
import { MessageService } from 'src/app/services/message.service';
import { TranslateService } from '@ngx-translate/core';
import { EditbaseComponent } from '../../editbase.component';
import { RoleService } from 'src/app/services/users/role.service';
import { FormsService } from 'src/app/services/forms/forms.service';
import { NewFormModel } from 'src/app/services/forms/new-form-model';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.less']
})
export class EditRoleComponent extends EditbaseComponent implements OnInit {


  componentData: NewFormModel | undefined;
  
  role:any = {
    Name:"",
    Description:"",
    DefaultUrl : "",
    RightsFormModel:{
      Rights:[]
    }
  };
  activetab :string = "basic-info";

  constructor(public formsService: FormsService,private activatedRoute: ActivatedRoute, public roleService: RoleService, public messageService:MessageService, 
    public submenuService:SubmenuService, public translate: TranslateService) { 

      super();
    }

  ngOnInit(): void {
    let roleId = this.activatedRoute.snapshot.params.roleId;

    if(roleId>0)
    {
      this.messageService.showLoading();
      this.roleService.loadById(roleId).subscribe((data:any) => {
        this.role = data;
        this.messageService.hideLoading();
      });
    }
    
    this.formsService.loadNewFormModel().subscribe((data:NewFormModel) => {
        this.componentData = data;
    });
  }

  setActiveTab(tabName:string){
    this.activetab  = tabName;
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/roles", this);  
  }

  save() {
    this.messageService.showLoading();
   this.roleService.save(this.role).subscribe((data:any) => {

      this.role = data;
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");

    });
  }

  addNewAdditionalRights() {
    
    
    const newRight = JSON.parse(JSON.stringify(this.role.RightsFormModel[0]));
    
    for(var i = 0; i<newRight.Rights.length; i++){
      newRight.Rights[i].DenySelected = false;
      newRight.Rights[i].AllowSelected = false;
    }
    this.role.RightsFormModel.push(newRight);
  }

  delete() {
    
  }

  remove(rm) {
    rm.deleted = true;
    for(var i = 0; i<rm.Rights.length; i++){
      rm.Rights[i].DenySelected = false;
      rm.Rights[i].AllowSelected = false;
    }
  }

  allowAll(rm){
    for(var i = 0; i<rm.Rights.length; i++){
      rm.Rights[i].DenySelected = false;
      rm.Rights[i].AllowSelected = true;
    }
  }

  denyAll(rm){
    for(var i = 0; i<rm.Rights.length; i++){
      rm.Rights[i].DenySelected = true;
      rm.Rights[i].AllowSelected = false;
    }
  }
}
